import { __read } from "tslib";
import React, { lazy } from 'react';
/**
 * Context to provide AIHubSharedExecutionContextProvider props
 * This allow component that require AIHubSharedExecutionContextProvider
 * to request for AIHubSharedExecutionContextProvider to be loaded
 */
export var AIHubSharedExecutionContextProviderPropsContext = React.createContext(undefined);
/**
 * Bare minimum AIHubSharedExecutionContextProvider component
 **/
export var AIHubSharedExecutionContextProviderAppContext = React.createContext(undefined);
/**
 * Lazy loading AIHubSharedExecutionContextProvider (V2 and copilot)
 * This is needed for App to wrap with ErrorBoundary
 */
export var AIHubSharedExecutionContextProviderLazy = lazy(function () {
    return import(
    /* webpackChunkName: "ai-hub-execution-context-service" */ '@office-start/ai-hub-execution-context-service');
});
/** helper function to ensure AIHubShareExecutionContext should be loaded is loaded */
export var SetupAIHubSharedExecutionContextProvider = function (_a) {
    var children = _a.children;
    var sharedExecutionContextProviderAppContextProps = React.useContext(AIHubSharedExecutionContextProviderAppContext);
    var _b = sharedExecutionContextProviderAppContextProps || {}, officeExperienceContext = _b.officeExperienceContext, workload = _b.workload, initialLoadAIHubSharedContext = _b.initialLoadAIHubSharedContext, AIHubSharedExecutionContextProviderLazyErrorBoundary = _b.AIHubSharedExecutionContextProviderLazyErrorBoundary;
    /**
     * state for Lazy loading AIHubSharedExecutionContextProvider (V2 and copilot)
     */
    var _c = __read(React.useState(initialLoadAIHubSharedContext), 2), loadAIHubShareContext = _c[0], setLoadAIHubShareContext = _c[1];
    // helper function to ensure AIHubShareExecutionContext ensure that
    // AIHubSharedExecutionContextProvider is loaded
    var ensureLoadAIHub = React.useCallback(function () {
        // avoid error for reqct that set state while rendering a different component
        Promise.resolve().then(function () {
            setLoadAIHubShareContext(true);
        });
    }, []);
    var aiHubShareContextValueProps = React.useMemo(function () { return ({
        loadAIHubShareContext: !!loadAIHubShareContext,
        ensureLoadAIHub: ensureLoadAIHub,
    }); }, [loadAIHubShareContext, ensureLoadAIHub]);
    if (!AIHubSharedExecutionContextProviderLazyErrorBoundary ||
        !officeExperienceContext ||
        !workload) {
        return null;
    }
    return (React.createElement(AIHubSharedExecutionContextProviderPropsContext.Provider, { value: aiHubShareContextValueProps }, loadAIHubShareContext ? (React.createElement(AIHubSharedExecutionContextProviderLazyErrorBoundary, { officeExperienceContext: officeExperienceContext, workload: workload }, children)) : (React.createElement(React.Fragment, null, children))));
};
/**
 * Hook to for module to ensure AIHubSharedExecutionContextProvider is loaded if not already loaded
 *
 */
export var useEnsureAIHubSharedExecutionContext = function () {
    var ensureLoadAIHub = (React.useContext(AIHubSharedExecutionContextProviderPropsContext) || {}).ensureLoadAIHub;
    if (!ensureLoadAIHub) {
        throw new Error('useEnsureAIHubSharedExecutionContext must be used within an AIHubSharedExecutionContextProviderPropsContext');
    }
    ensureLoadAIHub();
};
//# sourceMappingURL=AiHubExecutionContextProviderLazy.js.map